import { DateTime } from 'luxon';
import { useTimezone } from '../lib/TimezoneContext';

export function PickerTzLabel({
  className,
  title,
}: {
  className?: string;
  title?: string;
} = {}) {
  const tz = useTimezone();
  const abbr = DateTime.now().setZone(tz).toFormat("ZZZZ");
  return (
    <span className={className ?? "text-[10px] text-[var(--c-ink-3)]"} title={title}>
      {tz} ({abbr})
    </span>
  );
}
